import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import { formatDateAEL } from 'utils/formatters/arts';

import {
    SECT_APPLICANT,
    SECT_EVENT_DETAILS,
    SECT_EVENT_VENUE,
    SECT_FILER,
    SECT_ORGANISATION,
    SECT_PERFORMER
} from 'common/application.const';

export const formatAEL = async (licenceDetails: any, content: any) => {
    let licence;

    const dateTimeValues = (licenceDetails.dateSAndTimeSOfTheArtsEntertainment || []).map((dateTime: { [key: string]: string }) => ({
        from: formatDateAEL(dateTime.startingDateOfEvent || '-', dateTime.startingTimeOfEventHr || '-'),
        to: formatDateAEL(dateTime.endingDateOfEvent || '-', dateTime.endingTimeOfEventHr || '-')
    }));
    const performerValues = (licenceDetails.listOfPerformersArtists || []).map((performer: { [key: string]: string }) => ({
        artist: performer.nameOfPerformersArtists,
        country: performer.country,
        'group-band': performer.groupBandName,
        uploaded: 'true'
    }));
    licence = {
        id: 'event-ael',
        formID: 'event-ael',
        hasError: true,
        title: 'Event Details',
        values: {
            [`${SECT_EVENT_DETAILS}-event-title`]: licenceDetails?.detailsOfTheArtsEntertainment?.titleOfEvent ?? '',
            [`${SECT_EVENT_DETAILS}-event-type`]: licenceDetails?.detailsOfTheArtsEntertainment?.eventType ?? '',
            [`${SECT_EVENT_DETAILS}-event-desc`]:
                licenceDetails?.detailsOfTheArtsEntertainment?.provideABriefDescriptionOfTheEventThemeContentsToBeHeld ?? '',
            [`${SECT_EVENT_DETAILS}-event-sub-type`]: licenceDetails?.detailsOfTheArtsEntertainment?.SubType ?? '',
            [`${SECT_EVENT_DETAILS}-language`]: licenceDetails?.detailsOfTheArtsEntertainment?.languageOfEventType ?? '',
            [`${SECT_EVENT_DETAILS}-offered-online`]:
                licenceDetails?.detailsOfTheArtsEntertainment?.willThePerformanceBeOfferedOnline ?? '',
            [`${SECT_EVENT_DETAILS}-form-of-public-entertainment`]:
                licenceDetails?.detailsOfTheArtsEntertainment?.isThereAnyFormOfPublicEntertainmentDuringTheEvent ?? '',
            [`${SECT_EVENT_DETAILS}-in-out`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.typeOfVenue ?? '',
            [`${SECT_EVENT_DETAILS}-maximum-seats-per-show`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided
                    ?.ifSeatsAreProvidedStateTheMaximumNumberOfSeatsPerShow ?? '',
            [`${SECT_EVENT_DETAILS}-event-date-time`]: dateTimeValues,
            [`${SECT_EVENT_DETAILS}-admission-fee`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.stateSeatPriceAdmissionFees ?? '',
            [`${SECT_EVENT_DETAILS}-crowd-size`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.expectedCrowdSize ?? '',
            [`${SECT_EVENT_VENUE}-address-type`]: 'SG',
            [`${SECT_EVENT_VENUE}-postal`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.eventVenueAddress?.postalCode ?? '',
            [`${SECT_EVENT_VENUE}-block-house`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.eventVenueAddress?.blockNo ?? '',
            [`${SECT_EVENT_VENUE}-street`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.eventVenueAddress?.streetName ?? '',
            [`${SECT_EVENT_VENUE}-floor`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.eventVenueAddress?.floor ?? '',
            [`${SECT_EVENT_VENUE}-unit`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.eventVenueAddress?.unit ?? '',
            [`${SECT_EVENT_VENUE}-building`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.eventVenueAddress?.buildingName ?? '',
            [`${SECT_EVENT_VENUE}-desc-venue`]:
                licenceDetails?.particularsOfThePlaceWhereTheArtsEntertainmentIsToBeProvided?.descriptionOfLocation ?? '',
            [`${SECT_PERFORMER}-performer-list`]: performerValues,
            CustomerStatus: content.BusinessStatus ?? content.status,
            RejectionRemarks: content.RejectionRemarks ?? ''
        }
    };
    return licence;
};

const aelPayload = {
    formatAEL
};

export default aelPayload;
